module.exports = "/fonts/Roboto-ThinItalic.ttf?d687b55c234963880ef732ab1eabbb01";